import { useFocusableGroup, useTabsterAttributes } from '@fluentui/react-tabster';
export const useMessageAttributes = ({
  id,
  defaultFocused
}) => {
  // Initialize groupper
  useFocusableGroup();
  const accessibleProps = {
    role: 'article',
    tabIndex: 0,
    id,
    'aria-labelledby': `${id}`
  };
  const tabsterProps = useTabsterAttributes({
    groupper: {
      tabbability: 2 /*limitedTrapFocus*/
    },

    focusable: {
      isDefault: defaultFocused
    }
  });
  return {
    ...accessibleProps,
    ...tabsterProps
  };
};
//# sourceMappingURL=useMessageAttributes.js.map